export class ResetState {
  static readonly type = '[Document] Reset State';
  constructor() {}
}

export class SetDocuments {
  static readonly type = '[Document] Set Documents';
  constructor(public documents: any[]) {}
}

export class UpdateDocument {
  static readonly type = '[Document] Update Document';
  constructor(public document: any) {}
}

export class DeleteDocument {
  static readonly type = '[Document] Delete Document';
  constructor(public docID: any) {}
}

export class AddFiling {
  static readonly type = '[Filing] Add Filing';
  constructor(public filing: any) {}
}

export class UpdateFiling {
  static readonly type = '[Filing] Update Filing';
  constructor(public filing: any) {}
}

export class UpdateFilingReferences {
  static readonly type = '[Filing] Update Filing References';
  constructor(public filingTemplate: any) {}
}

export class DeleteFiling {
  static readonly type = '[Filing] Delete Filing';
  constructor() {}
}

export class DeleteNewFilings {
  static readonly type = '[Filing] Delete New Filings';
  constructor() {}
}

export class AddTask {
  static readonly type = '[Task] Add Task';
  constructor(public Task: any) {}
}

export class UpdateTask {
  static readonly type = '[Task] Update Task';
  constructor(public Task: any) {}
}

export class DeleteTask {
  static readonly type = '[Task] Delete Task';
  constructor(public taskID: string) {}
}
